<template>
  <accordion ref="accordion" v-model="mostrarAccordion">
    <div slot="header">5. Endereço</div>
    <unicom-linha :espacamento="false" class="medio" v-if="!loading">
      <unicom-coluna
        sm="12"
        md="6"
        :class="$breakpoint.smAndDown ? 'mb-2' : ''"
      >
        <div>
          <span class="segunda-cor-fonte"> Código de referência: </span>
          <span> {{ objetoInformacoes.codigoReferencia }} </span>
        </div>
      </unicom-coluna>
      <unicom-coluna sm="12" md="6">
        <unicom-linha :espacamento="false">
          <unicom-coluna sm="auto" style="padding-right: 16px">
            <unicom-icone nome="map-pin" :tamanho="20" />
          </unicom-coluna>
          <unicom-coluna sm="9" md="10">
            <div>
              {{
                `${primeiraLetraMaiuscula(
                  objetoInformacoes.logradouro
                )}, ${primeiraLetraMaiuscula(
                  objetoInformacoes.numero
                )}, ${primeiraLetraMaiuscula(objetoInformacoes.bairro)},`
              }}
            </div>
            <div style="padding: 8px 0">
              {{ objetoInformacoes.cidade }}
              - {{ objetoInformacoes.uf }}
            </div>
            <div>{{ mascaraCep(objetoInformacoes.cep) }}</div>
            <div style="padding: 24px 0">
              <span class="segunda-cor-fonte"> Código municipal: </span>
              <span> {{ objetoInformacoes.codigoMunicipal }} </span>
            </div>
            <unicom-linha :espacamento="false">
              <unicom-coluna sm="auto" style="padding-right: 24px">
                <span class="segunda-cor-fonte"> Latitude: </span>
                <span> {{ objetoInformacoes.latitude }} </span>
              </unicom-coluna>
              <unicom-coluna sm="auto">
                <span class="segunda-cor-fonte"> Longitude: </span>
                <span> {{ objetoInformacoes.longitude }} </span>
              </unicom-coluna>
            </unicom-linha>
          </unicom-coluna>
        </unicom-linha>
      </unicom-coluna>
    </unicom-linha>
    <unicom-spinner
      v-else
      style="min-height: 76px"
      :tamanhoLoading="62"
      :tamanhoLinha="7"
      :velocidade="0.5"
      :marginTopTexto="30"
      mensagem="Carregando..."
    />
  </accordion>
</template>

<script>
import DadosGeraisMixin from "../DadosGeraisMixin";

export default {
  name: "Enderecos",
  mixins: [DadosGeraisMixin],
  data() {
    return {
      objetoInformacoes: {
        codigoReferencia: 0,
        logradouro: "",
        numero: "",
        bairro: "",
        cidade: "",
        uf: "",
        cep: "",
        codigoMunicipal: "",
        latitude: "",
        longitude: ""
      }
    };
  },
  methods: {
    formatarLongitudeLatitude(string) {
      return string.replace(/^(\d{2})(\d*).*/, "$1.$2");
    },
    init() {
      if (this.iniciado) return;

      this.loading = true;
      this.sleep(150).then(() => {
        this.getEndereco(this.idRnpPrestador)
          .then(res => {
            let objetoEndereco = res.data;

            Object.entries(objetoEndereco).forEach(e => {
              this.objetoInformacoes[e[0]] = e[1] ? e[1] : " - ";
            });

            this.iniciado = true;
          })
          .catch(() => {
            this.mostrarAccordion = false;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>
